module.exports = __webpack_public_path__ + "media/mike1.cabbb5d8.mp3";